import { render, staticRenderFns } from "./StartCDSLogin.vue?vue&type=template&id=71e62bb4"
import script from "./StartCDSLogin.vue?vue&type=script&lang=js"
export * from "./StartCDSLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports